// extracted by mini-css-extract-plugin
module.exports = {"terminalSocialButton":"terminalSocialButton__1ESKd","message":"message__3cjFy","signInButton":"signInButton__3qb5g"};